// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 343 ? "DesktopView" : chunkId) + "." + {"343":"4d0e6e7a","422":"c1fabf7b"}[chunkId] + ".chunk.css";
};